import http from './http';

export default {
  all(query) {
    return http().get(`/v1/task_templates?${query}`);
  },
  get(id) {
    return http().get(`/v1/task_templates/${id}`);
  },
  create(data) {
    return http().post(`/v1/task_templates`, data);
  },
  update(data) {
    return http().put(`/v1/task_templates/${data.id}`, data);
  },
  delete(id) {
    return http().delete(`/v1/task_templates/${id}`);
  },
  detachFromAutomation(id, automationId) {
    return http().delete(`/v1/task_templates/${id}/automation/${automationId}`);
  },
  attachToAutomation(id, automationId) {
    return http().post(`/v1/task_templates/${id}/automation/${automationId}`);
  },
}
